import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { combineReducers } from 'redux'
import { schema, normalize } from 'normalizr'

const normalizeFeedItems = data => {
  const items = new schema.Entity('items')
  return normalize(data, [items])
}

const updateFilters = state => ({
  ...state,
  updateAfter: Date.now()
})

const FeedItemsReducer = combineReducers({
  fetchItemsRequest: createRequestReducer('FEED_ITEMS:FETCH'),
  rejectWorkRequest: createRequestReducer('FEED_ITEMS:REJECT_WORK'),
  approveWorkRequest: createRequestReducer('FEED_ITEMS:APPROVE_WORK'),
  filters: createReducer(
    { session_id: null, student_id: null, updateAfter: Date.now() },
    {
      'FEED_ITEMS:FETCH_REQUEST': (state, { params }) => ({
        ...state,
        session_id: params.session_id || null,
        student_id: params.student_id || null
      }),
      'FEED_ITEMS:REJECT_WORK_REQUEST_SUCCESS': updateFilters,
      'FEED_ITEMS:APPROVE_WORK_REQUEST_SUCCESS': updateFilters,
      'FEED_ITEMS:ADD_STUDENTS_TO_SESSION_REQUEST_SUCCESS': updateFilters
    }
  ),
  data: createReducer(null, {
    'FEED_ITEMS:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      normalizeFeedItems(response.data.pa_action_feed_items),
    'FEED_ITEMS:REJECT_WORK_REQUEST': (state, { params }) => ({
      ...state,
      result: state.result.filter(id => id !== params.feedId)
    }),
    'FEED_ITEMS:APPROVE_WORK_REQUEST_SUCCESS': (state, { params }) => ({
      ...state,
      result: state.result.filter(id => id !== params.feedId)
    })
  })
})

export default FeedItemsReducer
